import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, of } from "rxjs";
import { LeadService } from "../services/lead.service";
import { Quote } from "../../shared/models/quote.interface";
import { catchError, finalize } from "rxjs/operators";
import { LeadFilter } from "../models/lead.filter";

export class LeadsDataSource implements DataSource<Quote> {
  private leadsSubject = new BehaviorSubject<Quote[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private leadService: LeadService) { }

  connect(collectionViewer: CollectionViewer): Observable<Quote[]> {
    return this.leadsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.leadsSubject.complete();
    this.loadingSubject.complete();
  }

  loadLeads(filter: LeadFilter,
    sortColumn = 'projectName', sortDirection = 'asc', pageIndex = 0, pageSize = 25) {

    this.loadingSubject.next(true);

    this.leadService.getList(filter, sortColumn, sortDirection, pageIndex, pageSize).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(lessons => this.leadsSubject.next(lessons));
  }
}
